import { FaDatabase, FaChartPie, FaGlobe, FaFileAlt, FaShieldAlt, FaBolt } from "react-icons/fa";

const KeyFeatures = () => {
    const mainFeatures = [
        {
            title: "Comprehensive Company Profiles",
            description: "Access detailed information including industry type, size, location, and legal activity.",
            image: "/images/key-features-1.png",
            icon: <FaDatabase className="text-blue-600" />,
            highlights: ["Industry Classification", "Company Size Analysis", "Legal Activity Tracking"]
        },
        {
            title: "Dynamic Risk Scoring",
            description: "Get a risk assessment score based on multiple risk factors like industry performance, financial reports, and location analysis.",
            image: "/images/key-features-2.png",
            icon: <FaChartPie className="text-green-600" />,
            highlights: ["Real-time Scoring", "Multi-factor Analysis", "Predictive Insights"]
        }
    ];

    const additionalFeatures = [
        {
            icon: <FaGlobe className="text-2xl text-blue-500" />,
            title: "Global Coverage",
            description: "Access risk data for companies across Europe"
        },
        {
            icon: <FaFileAlt className="text-2xl text-purple-500" />,
            title: "Detailed Reports",
            description: "Generate comprehensive PDF reports instantly"
        },
        {
            icon: <FaShieldAlt className="text-2xl text-green-500" />,
            title: "Data Security",
            description: "Bank-level encryption for all your data"
        },
        {
            icon: <FaBolt className="text-2xl text-yellow-500" />,
            title: "Lightning Fast",
            description: "Get results in seconds, not hours"
        }
    ];

    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-6xl mx-auto px-8">
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        Powerful Features for Smart Decisions
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Everything you need to assess and manage risk effectively in one platform
                    </p>
                </div>

                {/* Main Features */}
                <div className="grid lg:grid-cols-2 gap-8 mb-16">
                    {mainFeatures.map((feature, index) => (
                        <div key={index} className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow">
                            <div className="h-48 overflow-hidden">
                                <img 
                                    src={feature.image} 
                                    alt={feature.title}
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <div className="p-8">
                                <div className="flex items-center mb-4">
                                    <div className="text-2xl mr-3">{feature.icon}</div>
                                    <h3 className="text-2xl font-bold text-gray-900">
                                        {feature.title}
                                    </h3>
                                </div>
                                <p className="text-gray-600 mb-6">
                                    {feature.description}
                                </p>
                                <div className="space-y-2">
                                    {feature.highlights.map((highlight, idx) => (
                                        <div key={idx} className="flex items-center text-sm text-gray-600">
                                            <span className="text-green-500 mr-2">✓</span>
                                            {highlight}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Additional Features Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {additionalFeatures.map((feature, index) => (
                        <div key={index} className="bg-white rounded-xl p-6 text-center hover:shadow-lg transition-shadow">
                            <div className="flex justify-center mb-4">
                                {feature.icon}
                            </div>
                            <h4 className="font-semibold text-gray-900 mb-2">
                                {feature.title}
                            </h4>
                            <p className="text-sm text-gray-600">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default KeyFeatures;